import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"

const useTags = () => {
  const [tags, setTags] = useState([])
  const {
    data: tagResponse,
    isLoading,
    isError,
    isFetching,
  } = useCustomQuery(["tag-all"], "tags/all")

  useEffect(() => {
    if (tagResponse?.data) {
      setTags(tagResponse.data)
    }
  }, [tagResponse])
  return {
    tags,
    isLoading,
    isError,
    isFetching,
    setTags,
  }
}

export default useTags
